import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from '../../../shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { Entity, HeaderMenuType } from '../../../shared/store/view/types';
import { ModuleId } from '../../../shared/store/navigation/types';
import { CarReferenceBrandDetailsComponent } from './car-reference-brand-details/car-reference-brand-details.component';
import { CarReferenceBrandCreateComponent } from './car-reference-brand-create/car-reference-brand-create.component';
import { CarReferenceBrandEditComponent } from './car-reference-brand-edit/car-reference-brand-edit.component';

const routes: Routes = [
  {
    path: 'Crm/CarReferenceBrands',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.CarReferenceBrand,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: CarReferenceBrandDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.CarReferenceBrand,
          breadcrumb: { label: ' ', alias: 'carReferenceBrandDetails' },
        },
      },
      {
        path: 'Create',
        component: CarReferenceBrandCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.CarReferenceBrand,
          breadcrumb: { label: ' ', alias: 'carReferenceBrandCreate' },
        },
      },
      {
        path: 'Edit/:id',
        component: CarReferenceBrandEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.CarReferenceBrand,
          breadcrumb: { label: ' ', alias: 'carReferenceBrandEdit' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CarReferenceBrandRoutingModule {}
